export const getUrlSearchParams = () => {
    return new URLSearchParams(window.location.search);
};

export const getAbsoluteUrlWithParams = (pathName: string) =>
    `${window.location.origin}${pathName}${window.location.search}`;
